import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import Avatar from "react-avatar";
import { VALIDATION_FIELD_MAPPING } from '../../../../../utils/appConstant';
import ElipsisText from "../../../../../components/ElipsisText";
import ElipsisCell from "../../../../../components/TableBox/Cells/EllipsisCell";
import Link from "../../../../../components/Link";
import Badge from "../../../../../components/Badge";
import Checkbox from "../../../../../components/Checkbox";
import { RowClassName, Modules, AuthRoutes, RouteParamsTypes } from "../../../../../enums";
import { TableContext } from "../../../../../contexts/TableContext";
import NoPropertyImg from '../../../../../assets/img/custom/no-property.jpeg';

interface RowProps {
  item: any;
  className?: RowClassName;
  selectedIds: string[];
  onSelectToggle: (id: string) => void;
}

const AssignPropertiesModalRow: React.FC<RowProps> = ({ item, className, selectedIds, onSelectToggle }) => {
  const { t } = useTranslation();
  const { headCells } = useContext(TableContext);

  const isSelected = selectedIds.includes(item.id);

  const propertyNode = (
    <div className="d-flex align-items-center">
      <div className="me-2" style={{ width: 42 }}>
        <Avatar src={item.picture_url || NoPropertyImg} name={item.name} size="40" maxInitials={2} round />
      </div>
      <div style={{ width: 'calc(100% - 52px)' }}>
        <ElipsisText
          width="100%"
          text={item.name || '-'}
          node={
            <Link
              text={item.name || '-'}
              href={`${Modules.resources}${AuthRoutes.properties}${RouteParamsTypes.view}/${item.id}`}
              onClick={() => window.open(`${Modules.resources}${AuthRoutes.properties}${RouteParamsTypes.view}/${item.id}`, '_blank')}
            />
          }
          className="h6 mb-1 text-decoration-underline hyperlink"
        />
        <ElipsisText width="100%" text={item?.city_data?.name || '-'} />
      </div>
    </div>
  );

  const managedByNode = (
    <div>
      <ElipsisText width="100%" text={item?.manager?.name ?? '-'} />
    </div>
  );

  const customerNode = (
    <div>
      <ElipsisText width="100%" text={item?.customer?.name ?? '-'} className="h6 mb-1" />
      <ElipsisText width="100%" text={item?.customer?.email ?? '-'} />
    </div>
  );

  return (
    <tr className={className}>
      {
        headCells.map((headCell) => {
          if (headCell.id === VALIDATION_FIELD_MAPPING.select) {
            return (
              <td key={headCell.id} width={headCell.width}>
                <Checkbox
                  variant='primary'
                  className='d-checkbox mb-0'
                  checked={isSelected}
                  name={VALIDATION_FIELD_MAPPING.select}
                  onChange={() => onSelectToggle(item.id)}
                />
              </td>
            );
          }

          if (headCell.id === VALIDATION_FIELD_MAPPING.name) {
            return (
              <ElipsisCell key={headCell.id} width={headCell.width} node={propertyNode} />
            );
          }

          if (headCell.id === VALIDATION_FIELD_MAPPING.status) {
            return (
              <td key={headCell.id} width={headCell.width}>
                <Badge
                  text={item.is_active ? t("property.list.pageTexts.table.status.active") : t("property.list.pageTexts.table.status.inActive")}
                  variant={item.is_active ? 'success' : 'danger'}
                />
              </td>
            );
          }

          if (headCell.id === VALIDATION_FIELD_MAPPING.customer) {
            return (
              <ElipsisCell key={headCell.id} width={headCell.width} node={customerNode} />
            );
          }

          if (headCell.id === VALIDATION_FIELD_MAPPING.managedBy) {
            return (
              <ElipsisCell key={headCell.id} width={headCell.width} node={managedByNode} />
            );
          }

          if (headCell.id === VALIDATION_FIELD_MAPPING.commissionPercentage) {
            return (
              <ElipsisCell
                key={headCell.id}
                width={headCell.width}
                text={typeof item?.commission_percentage !== 'undefined' && item?.commission_percentage !== null ? `${item.commission_percentage}%` : '-'}
              />
            );
          }

          return (<ElipsisCell key={headCell.id} width={headCell.width} text={item[headCell.id] || '-'} />);
        })
      }
    </tr>
  );
};

export default AssignPropertiesModalRow;
